@if (isBusy || profileService.isSearchingCustomers) {
  <div class="scroll-content">
    <app-overlay imgClass='cg-overlay-img'></app-overlay>
  </div>
}
@if (!isBusy && !profileService.isSearchingCustomers) {
  <div
    [ngClass]="scrollContentClass"
    style="flex: none !important;"
    infinite-scroll
    [infiniteScrollDistance]="10"
    [infiniteScrollThrottle]="300"
    [scrollWindow]="false"
    (scrolled)="onScrollDown()">
    <div id="content-list" class="list list-md">
      @for (customer of customers; track customer) {
        <button class="item item-block item-md" text-wrap=""
          (click)="profileService.updateCustomerSelection(customer)">
          <div class="item-inner">
            <div class="input-wrapper width-100">
              <div class="list-label label label-md width-100 padding-left-5 padding-right-5">
                <div class="ellipses-label">{{ customer.customer_name }}</div>
              </div>
              <div class="arrow-container">
                <div class="arrow-wrapper radio-wrapper">
                  <input type="radio" value="{{customer.customer_id}}"
                    [checked]="profileService.isCustomerSelected(customer.customer_id)" class="radio"/>
                </div>
              </div>
            </div>
            <div class="button-effect"></div>
          </div>
        </button>
      }
      <!--<app-button-radio
      *ngFor="let customer of customers"
      [label]="customer.customer_name"
      [value]="customer.customer_id"
      [onClick]="onOptionSelect.bind(this)"
      [selected]="selected()"
      />-->
    </div>
  </div>
}
